import { Box, Link, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { HeadTag } from 'shared/components';

const FinishUploadReworkPage = (): ReactElement => {
    /**
     * Handle onlick of logo in footer area
     */
    const handleLogoFooterOnClick = React.useCallback(() => {
        // navigation('/manage-cross-checks');
    }, []);
    return (
        <>
            <HeadTag title="Finish Upload Documents" />
            <Box className="finish-wrapper">
                <Typography variant="h1">Good Job!</Typography>
                <Typography>Document on this Cross check</Typography>
                <Typography>is no longer missing</Typography>
                <br />
                <Typography>If you require any further assistance,</Typography>
                <Typography>
                    please contact us at:{' '}
                    <Link href="mailto:support@doxai.co">support@doxai.co</Link>
                </Typography>
                <Box className="menu-footer">
                    <img
                        className="app-logo"
                        src="/images/brand/logo-pepper-money.png"
                        onClick={handleLogoFooterOnClick}
                        alt="Peppermoney logo"
                        width={98}
                        height={45}
                    />
                </Box>
            </Box>
        </>
    );
};

export default FinishUploadReworkPage;
